import _ from 'lodash'
import { store } from 'state-pool'

import {
  BRAND_CODES,
  BRAND_DEFAULT_CALENDAR_START_DATE,
  BRAND_ID,
  BRAND_LOCATION_GROUP_ID,
} from 'pared/constants/brands'

export function getBrand() {
  const brand = _.get(store, 'value.brand', '')

  const currentBrand = !_.isEmpty(brand)
    ? store.getState('brand').value
    : BRAND_CODES[0]
  return currentBrand
}

export function getBrandId() {
  const brand = getBrand()
  return BRAND_ID[brand]
}

export function getBrandLocationGroupId() {
  const brand = getBrand()
  return BRAND_LOCATION_GROUP_ID[brand]
}

export function getBrandFromPathname(pathname: string) {
  const splitPathName = _.split(pathname, '/')

  let brand = BRAND_CODES[0]
  if (_.size(splitPathName) >= 2) {
    const brandVar = splitPathName[1]

    if (_.includes(BRAND_CODES, brandVar)) {
      return brandVar
    }
  }
  return brand
}

export function getPathnameWithoutBrand(pathname: string) {
  const splitPathName = _.split(pathname, '/')

  if (_.size(splitPathName) >= 2) {
    const restUrl = splitPathName[2]

    return `/${restUrl}`
  }
  return pathname
}

export function getBrandDefaultCalendarStartDate() {
  const brand = getBrand()
  return BRAND_DEFAULT_CALENDAR_START_DATE[brand]
}

export function isDrgBrand() {
  const brand = getBrand()
  switch (brand) {
    case 'sullivans':
    case 'sullivans_nso':
    case 'eddiemerlots':
    case 'eddiemerlots_nso':
      return true
    default:
      return false
  }
}
